import React, { useEffect, useRef, useMemo } from 'react';
import utils from '@/common/utils';
import Container from '@/components/container';
import TabNav from '@/components/slide-menu/tab-nav';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import CollectionPoolList from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/collection-pool-list/index.js';
import PoolList from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/pool-list';
import data from '../constants/data';
import { useLocation } from 'react-router-dom';
import IsNewActivity from '../is-new-activity';

const perfomanceStyle = {
  zIndex: 1,
  position: 'relative',
  marginBottom: '-47px',
  top: '168px',
};

// 头部和身体因为tab的存在只能分开两个微前端加载
// canPerformance可以只加载一个微前端
export default function List(props) {
  const isManage = !Number(utils.getQuery('entry'));
  // activityVersion 开放报名3
  // 会场活动4 新加的
  // 只有会场活动才有流程数据 activityInfo.activityVersion === 4
  const { showHead = true } = props;

  // start 性能优化，在收品池列表和效果数据两个tab下避免微前端加载两遍
  const location = useLocation();
  const { pathname } = location;

  const canPerformance = useMemo(() => {
    // 流程数据下无法进行优化
    return pathname.indexOf('/manage') === -1 && showHead;
  }, [pathname, showHead]);
  // end 性能优化

  return (
    <Container>
      {/* 只展示头部并且不能性能优化 */}
      {/* showHead表示老版本日常活动，因为老版本日常活动才需要头部 */}
      {showHead && (
        <IsNewActivity>
          {!canPerformance &&
            (isManage ? (
              <CollectionPoolList
                name="collectionTibaoRoomInHeader"
                needLoading={false}
                destory
                data={{ ...data, headerOnly: true }}
                needFeedBack={false}
              />
            ) : (
              <PoolList
                destory
                name="poolListTibaoRoomInHeader"
                needLoading={false}
                data={{ ...data, headerOnly: true }}
              />
            ))}
        </IsNewActivity>
      )}
      <ContextProviderMenus.Provider value={{ children: props.children, isManage, canPerformance }}>
        <div style={canPerformance ? perfomanceStyle : undefined}>
          <TabNav className="padding-horizontal" />
        </div>
        {props.children}
      </ContextProviderMenus.Provider>
    </Container>
  );
}
